import { useState } from 'react';

function ComputerNetworkingModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Computer Networks",
      content: [
        "What is a computer network?",
        "Importance and applications of computer networks",
        "Types of networks: LAN, WAN, MAN, PAN",
        "Network components: Router, Switch, Hub, Modem",
        "Basic network topology: Bus, Star, Ring, Mesh",
        "Network devices and their functions"
      ]
    },
    {
      title: "Module 2: Network Models",
      content: [
        "The OSI Model: Layers and Functions",
        "TCP/IP Model: Layers and Functions",
        "Comparison between OSI and TCP/IP Models",
        "Protocol Stack",
        "Encapsulation and De-encapsulation in Networking"
      ]
    },
    {
      title: "Module 3: Data Transmission",
      content: [
        "Analog and Digital Transmission",
        "Types of transmission: Simplex, Half-Duplex, Full-Duplex",
        "Transmission Media: Wired vs Wireless",
        "Bandwidth and Data Rate",
        "Data Encoding Methods",
        "Error Detection and Correction Techniques"
      ]
    },
    {
      title: "Module 4: Networking Devices",
      content: [
        "Hubs, Switches, Routers, and Modems",
        "Bridges, Gateways, and Repeaters",
        "Functioning of Switches and Routers",
        "Network Interface Cards (NIC)",
        "Types of Cabling: Twisted Pair, Fiber Optic, Coaxial",
        "Wireless Communication Devices: Wi-Fi, Bluetooth, Zigbee"
      ]
    },
    {
      title: "Module 5: IP Addressing and Subnetting",
      content: [
        "What is an IP Address?",
        "IPv4 vs IPv6",
        "Subnet Mask and Network Address",
        "Subnetting: Concept and Techniques",
        "Classful and Classless IP Addressing",
        "CIDR Notation and Subnetting Calculator",
        "Private and Public IP Addresses"
      ]
    },
    {
      title: "Module 6: Routing and Switching",
      content: [
        "Routing Basics: Static vs Dynamic Routing",
        "Routing Algorithms: Distance Vector, Link-State",
        "IP Routing: Routing Tables, Next Hop",
        "Switching: Circuit Switching, Packet Switching",
        "VLANs (Virtual LANs)",
        "Ethernet Switching: MAC Addresses and Frame Forwarding"
      ]
    },
    {
      title: "Module 7: Network Protocols",
      content: [
        "What are Network Protocols?",
        "TCP/IP Protocol Suite",
        "Transmission Control Protocol (TCP)",
        "User Datagram Protocol (UDP)",
        "HyperText Transfer Protocol (HTTP)",
        "File Transfer Protocol (FTP)",
        "Simple Mail Transfer Protocol (SMTP)",
        "Post Office Protocol (POP3) and Internet Message Access Protocol (IMAP)",
        "Dynamic Host Configuration Protocol (DHCP)"
      ]
    },
    {
      title: "Module 8: Wireless Networks",
      content: [
        "Introduction to Wireless Networks",
        "Wi-Fi Standards (802.11 a/b/g/n/ac/ax)",
        "Bluetooth and its applications",
        "Zigbee and other IoT protocols",
        "Cellular Networks: 4G, 5G",
        "Wi-Fi Security Protocols: WEP, WPA, WPA2, WPA3",
        "RFID Technology and Applications"
      ]
    },
    {
      title: "Module 9: Network Security",
      content: [
        "Introduction to Network Security",
        "Common Security Threats: Viruses, Worms, Phishing",
        "Firewalls: Types and Functionality",
        "Network Intrusion Detection Systems (IDS) and Intrusion Prevention Systems (IPS)",
        "Virtual Private Network (VPN)",
        "Encryption and Cryptography",
        "Access Control and Authentication Techniques"
      ]
    },
    {
      title: "Module 10: Network Troubleshooting and Performance",
      content: [
        "Common Networking Issues and Solutions",
        "Ping, Traceroute, and Netstat Commands",
        "Diagnosing DNS and IP Address Issues",
        "Network Performance: Latency, Jitter, Packet Loss",
        "Quality of Service (QoS)",
        "Bandwidth Management and Traffic Shaping",
        "Tools for Network Monitoring and Analysis"
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Computer Networking Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px' }}>{item}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ComputerNetworkingModule;
